export const mutations = {
  setVenda(state, data) {
    state.venda = data;
  },
  setVendas(state, data) {
    state.vendas = data;
  },
  setProdutoVenda(state, data) {
    state.produtoVenda = data;
  },
  setProdutosVenda(state, data) {
    state.produtosVenda = data;
  },
  addVenda(state, data) {
    state.vendas.push(data);
  },
  removeVenda(state, data) {
    const index = state.vendas.map((x) => x.id).indexOf(data.id);
    state.vendas.splice(index, 1);
  },
  addProdutoVenda(state, data) {
    state.produtosVenda.push(data);
  },
  setProdutosVenda(state, data) {
    state.produtosVenda = data;
  },
  removeProdutoVenda(state, data) {
    const index = state.produtosVenda.map((x) => x).indexOf(data);
    state.produtosVenda.splice(index, 1);
  },
  setClienteVenda(state, data) {
    state.clienteVenda = data;
  },
  setModalExcluirVenda(state, status) {
    state.modalExcluirVenda = status;
  },
  setModalImprimirVenda(state, status) {
    state.modalImprimirVenda = status;
  },
  setModalVisualizarVenda(state, status) {
    state.modalVisualizarVenda = status;
  },
  setModalTrocaVenda(state, status) {
    state.modalTrocaVenda = status;
  },
  setModalListarVenda(state, status) {
    state.modalListarVenda = status;
  },
  setTotalVendaComDescontoAdicional(state, data) {
    state.totalVendaComDescontoAdicional = data;
  },
  setDescontoAdicionalTotalVenda(state, data) {
    state.descontoAdicionalTotalVenda = data;
  },
  setModalDescontoAdicionalVenda(state, status) {
    state.modalDescontoAdicionalVenda = status;
  },
  setModalExclusaoVenda(state, status) {
    state.modalExclusaoVenda = status;
  },
  setCheckListProdutoVenda(state, payload){
    state.checklistProdutoVenda = payload
  }
};

export default {};
